import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';

export default class ReportsAccountTemplatesRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;

	override beforeModel(): Promise<unknown> {
		const promises: Record<string, Promise<unknown>> = {};

		document.body.id = 'page-reports-account-templates';

		promises.initialRequests = this.navigationService.initialRequestsPromise;

		promises.accountTemplates = this.mmTemplatesService.requestReportAccountTemplates();

		void this.mmReportsService.requestReports(); // to show reports in templates modal while creating new account template

		return hashSettled(promises);
	}
}
